import styled from 'styled-components'
import { ContentHeader } from '../../../App'
import Select from '../../Form/Select'
import Heading from '../Heading'
import { useContext, useEffect, useRef } from 'react'
import { OrderDataContext, ErrorContext, LocationsContext } from "../Context/WaiterContext"
import { TimePicker } from 'react-ios-time-picker';
import { Text } from '@chakra-ui/react'
import { SingleDatepicker } from 'chakra-dayzed-datepicker'

function First ({ page }) {
    const myRef = useRef(null)
    const { order, setOrder } = useContext(OrderDataContext)
    const { errors, setErrors } = useContext(ErrorContext)
    const { locations } = useContext(LocationsContext)

    useEffect(() => {
        if (errors?.table || errors?.location) {
            myRef.current.scrollIntoView()
        }
    }, [errors])

    useEffect(() => {
        if (order.location) {
            setErrors((prev) => ({ ...prev, location: false }))
        }
    }, [order.location])

    useEffect(() => {
        if (order.table) {
            setErrors((prev) => ({ ...prev, table: false }))
        }
    }, [order.table])

    useEffect(() => {
        if (order.guests) {
            setErrors((prev) => ({ ...prev, guests: false }))
        }
    }, [order.guests])

    const setLocation = (value) => {
        setData('location', value)
    }

    const setTable = (value) => {
        setData('table', value)
    }

    const setGuests = (value) => {
        setData('guests', value)
    }

    const setTime = (value) => {
        setData('time', value)
    }

    const setDate = (value) => {
        setData('date', value)
    }

    const setData = (key, value) => {
        setOrder({
            ...order,
            [key]: value,
        })

    }

    const getLocations = () => {
        return locations.map(location => {
            return {
                key: location.location,
                value: location.title
            }
        });
    }

    const getTables = () => {
        if (!order.location) {
            return [{
                key: null,
                value: null,
            }];
        }

        let tableConfig = [1,2,3,4,5,6,7,8,9];
        if (order.location === 'restaurant') {
            tableConfig = [101, 102, 103, 104, 105, 106, 107, 108, 109, 110];
        } else if (order.location === 'to the room') {
            tableConfig = [111, 222, 333, 444, 555, 666, 777, 888, 999];
        } else if (order.location === 'terace') {
            tableConfig = [201, 202, 203, 204, 205, 206, 207, 208];
        }

        const tables = [{
            key: null,
            value: null,
        }];
        tableConfig.forEach((table) => {
            tables.push({
                key: table.toString(),
                value: table
            });
        })
        return tables;
    }

    const getGuests = () => {
        const guests = [{
            key: null,
            value: null,
        }];
        for (var i = 1; i <= 10; i++) {
            guests.push({
                key: i.toString(),
                value: i
            });
        }
        return guests;
    }
    return (
        <Wrapper>
            <ContentHeader>
                <Heading page={page} />
                <Form ref={myRef}>
                    {!order.id && <>
                        <Select
                            setValue={setLocation}
                            defaultValue={order.location}
                            selected={order.location}
                            options={getLocations()}
                            placeholder={'Select location'}
                            error={errors?.location}
                        />
                        <Select
                            setValue={setTable}
                            selected={order.table}
                            options={getTables()}
                            placeholder={'Select table'}
                            error={errors?.table}
                        />
                        <Select
                            setValue={setGuests}
                            // defaultValue={order.guests}
                            selected={order.guests}
                            options={getGuests()}
                            placeholder={'Select guest count'}
                            error={errors?.guests}
                        />

                        <SingleDatepicker
                            name="date-input"
                            date={order.date}
                            onDateChange={setDate}
                            propsConfigs={{
                                dayOfMonthBtnProps: {
                                    isInRangeBtnProps: {
                                        color: 'white',
                                        background: 'blackAlpha.800',
                                        border: 'none',
                                        _hover: {
                                            bg: 'green.400',
                                        },
                                    },
                                    selectedBtnProps: {
                                        color: 'white',
                                        background: 'blackAlpha.800',
                                        border: 'none',
                                        _hover: {
                                            bg: 'green.400',
                                        },
                                    },
                                    defaultBtnProps: {
                                        background: 'white',
                                        border: 'none',
                                        _hover: {
                                            bg: 'green.400',
                                            color: 'white',
                                        },
                                    },
                                },
                                popoverCompProps: {
                                    popoverContentProps: {
                                        rootProps: { zIndex: 9999 },
                                    },
                                },
                            }}
                            configs={{
                                dateFormat: 'yyyy-MM-dd HH:mm:ss',
                                firstDayOfWeek: 1,
                            }}
                        />
                        <HStackWrapper>
                            <Text position="absolute" color="black">Time:</Text>
                            <TimePicker onChange={setTime} value={order.time} id="custom-time-picker" />
                        </HStackWrapper>
                    </>}
                    {/* <Textarea placeholder={'Comment (optional)'} value={order.comment} setValue={setComment}/> */}
                </Form>
            </ContentHeader>
        </Wrapper>
    );
}

const HStackWrapper = styled.div`
    background-color: #f4f4f452;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 10px;
    padding: 10px;
    position: relative;
    text-align: left;
    font-size: 15px;
    color: ${props => props.selected ? '#000000' : '#00000078'};

    ${props => props.error && `
        color: red;
        border-color: red;
    `}

    img {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 12px;
    }

    select {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }
`;

const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
`

const Form = styled.div`
    margin-top: 20px;

    & > * {
        margin-bottom: 20px;
    }

`

export default First;
